// Permission constants for RBAC system
import { NEW_KEYS_LIST, DEAD_KEYS, upgradeRole } from './permissionCatalog';

export const PERMISSIONS = {
  // Dashboard
  view_dashboard: 'view_dashboard',
  view_kpi_dashboard: 'view_kpi_dashboard',
  view_kpi_ops: 'view_kpi_ops',
  view_kpi_employees: 'view_kpi_employees',
  view_kpi_fleet: 'view_kpi_fleet',
  view_kpi_contracts: 'view_kpi_contracts',
  view_kpi_financial: 'view_kpi_financial',
  sync_kpi_data: 'sync_kpi_data',
  view_kpi_drilldown: 'view_kpi_drilldown',
  manage_kpi_settings: 'manage_kpi_settings',

  // Fleet Management
  view_fleet_list: 'view_fleet_list',
  view_fleet_smart: 'view_fleet_smart',
  view_fleet_summary: 'view_fleet_summary',
  view_fleet_expiry: 'view_fleet_expiry',
  search_fleet: 'search_fleet',
  export_fleet: 'export_fleet',
  // Stats
  view_fleet_stats: 'view_fleet_stats',
  view_fleet_stat_active: 'view_fleet_stat_active',
  view_fleet_stat_expired: 'view_fleet_stat_expired',
  view_fleet_stat_invygo: 'view_fleet_stat_invygo',

  // Contract Management
  view_contracts: 'view_contracts', // Page access
  search_contracts: 'search_contracts',
  analyze_contracts_multicar: 'analyze_contracts_multicar',
  sync_contracts: 'sync_contracts',
  edit_contracts: 'edit_contracts',
  export_contracts: 'export_contracts',
  // Tabs
  view_contracts_tab_all: 'view_contracts_tab_all',
  view_contracts_tab_mismatch: 'view_contracts_tab_mismatch',
  view_contracts_tab_switchback: 'view_contracts_tab_switchback',
  view_contracts_tab_expired: 'view_contracts_tab_expired',

  // Staff Management
  view_staff: 'view_staff',
  search_staff: 'search_staff',
  manage_staff_data: 'manage_staff_data',
  share_staff_reports: 'share_staff_reports',
  edit_staff: 'edit_staff',
  delete_staff: 'delete_staff',
  view_staff_stats: 'view_staff_stats',

  // Maintenance
  view_maintenance: 'view_maintenance',
  save_maintenance_db: 'save_maintenance_db',
  reset_maintenance_db: 'reset_maintenance_db',
  add_maintenance_record: 'add_maintenance_record',
  export_maintenance: 'export_maintenance',
  view_incomplete_maintenance: 'view_incomplete_maintenance',
  view_completed_maintenance: 'view_completed_maintenance',
  edit_maintenance_record: 'edit_maintenance_record',
  delete_maintenance_record: 'delete_maintenance_record',

  // Fleet Service History
  view_service_history: 'view_service_history',
  add_service_record: 'add_service_record',
  edit_service_record: 'edit_service_record',
  delete_service_record: 'delete_service_record',
  add_inventory_item: 'add_inventory_item',
  edit_inventory_item: 'edit_inventory_item',
  delete_inventory_item: 'delete_inventory_item',
  view_service_tab: 'view_service_tab',
  view_inventory_tab: 'view_inventory_tab',
  view_inventory_purchase_history: 'view_inventory_purchase_history',
  view_upcoming_tab: 'view_upcoming_tab',

  // Invoice Generator
  view_invoices: 'view_invoices',
  view_invoice_salik: 'view_invoice_salik',
  view_invoice_parking: 'view_invoice_parking',
  view_invoice_traffic: 'view_invoice_traffic',
  invoice_mode_upload: 'invoice_mode_upload',
  invoice_mode_manual: 'invoice_mode_manual',
  preview_invoice: 'preview_invoice',
  generate_invoice_documents: 'generate_invoice_documents',

  // Operations Portal
  view_operations: 'view_operations',
  // - Reminder
  view_ops_reminder: 'view_ops_reminder',
  ops_refunds: 'ops_refunds',                            // Deposit refunds tab (30-day list + mark refunded)


  // - Mileage Calculator
  view_ops_mileage: 'view_ops_mileage',
  ops_mileage_booking_input: 'ops_mileage_booking_input',
  ops_mileage_add_trip: 'ops_mileage_add_trip',
  ops_mileage_export_excel: 'ops_mileage_export_excel',
  ops_mileage_export_image: 'ops_mileage_export_image',
  ops_mileage_generate_invoice: 'ops_mileage_generate_invoice',

  // - Fuel Calculator
  view_ops_fuel: 'view_ops_fuel',
  ops_fuel_booking_input: 'ops_fuel_booking_input',
  ops_fuel_add_trip: 'ops_fuel_add_trip',
  ops_fuel_export_excel: 'ops_fuel_export_excel',
  ops_fuel_export_image: 'ops_fuel_export_image',
  ops_fuel_generate_invoice: 'ops_fuel_generate_invoice',

  // - Archive Cloud Sync

  view_ops_backup: 'view_ops_backup',
  view_ops_discount: 'view_ops_discount',

  // Airport Dashboard
  view_airport_dashboard: 'view_airport_dashboard',

  // Booking Management (Contracts Ops)
  view_booking_management: 'view_booking_management',
  booking_refresh_cloud: 'booking_refresh_cloud',
  booking_save_cloud: 'booking_save_cloud',
  booking_run_check: 'booking_run_check',
  booking_refresh_cars: 'booking_refresh_cars',
  booking_reset_data: 'booking_reset_data',
  booking_migration_tool: 'booking_migration_tool',
  booking_export_results: 'booking_export_results',
  // No page uses it any more: the Daily rental report's 'Delete found' was removed (CON-06, owner 26 Sep 2026 -
  // Ejar contracts are never deleted). Kept because saved roles store it.
  booking_delete_contracts: 'booking_delete_contracts',

  // Daily Rental Report
  view_daily_booking: 'view_daily_booking',

  // Database (the Ejar sync panel + the staff list import; every other list comes from Ejar - owner, 28 Sep 2026)
  view_database: 'view_database',
  import_staff: 'import_staff',

  // Database Write Permissions (Global)
  write_fleet: 'write_fleet',
  write_contracts: 'write_contracts',
  write_staff: 'write_staff',
  write_custodies: 'write_custodies',
  write_expenses: 'write_expenses',
  write_settlements: 'write_settlements',

  // Matcher Master
  view_matcher: 'view_matcher',
  // - Tabs
  matcher_tab_contracts: 'matcher_tab_contracts',
  matcher_tab_unrented: 'matcher_tab_unrented',
  matcher_tab_repeated: 'matcher_tab_repeated',
  matcher_tab_parking: 'matcher_tab_parking',
  matcher_tab_salik: 'matcher_tab_salik',
  // - Actions
  matcher_action_session: 'matcher_action_session',
  matcher_action_export: 'matcher_action_export',
  // - Uploads
  matcher_source_fleet: 'matcher_source_fleet',
  // - Parking Sub-features
  matcher_parking_view_invygo: 'matcher_parking_view_invygo',
  matcher_parking_view_yelo: 'matcher_parking_view_yelo',
  // - Salik Sub-features
  matcher_salik_view_invygo: 'matcher_salik_view_invygo',
  matcher_salik_view_yelo: 'matcher_salik_view_yelo',
  matcher_salik_summary: 'matcher_salik_summary',
  matcher_tab_traffic: 'matcher_tab_traffic',
  matcher_traffic_view_all: 'matcher_traffic_view_all',
  matcher_traffic_toggle_payment: 'matcher_traffic_toggle_payment',
  matcher_traffic_export: 'matcher_traffic_export',
  matcher_tab_airport: 'matcher_tab_airport',

  // History Lens
  view_history: 'view_history',
  history_tab_single: 'history_tab_single',
  history_tab_multi: 'history_tab_multi',

  // The Engine
  view_engine: 'view_engine',

  // Customer Automation (Ejar + TARS). The names match the engine's own checks in
  // automation/routes.py - changing one side alone silently locks the page out.
  use_automation: 'use_automation',
  manage_automation_settings: 'manage_automation_settings',
  save_customer_on_ejar: 'save_customer_on_ejar',   // Automation: open a case, fill and save the customer in Ejar
  control_engine: 'control_engine',          // register / pull / mark / fix (write)
  pull_salik: 'pull_salik',                  // pull Salik / parking / Darb from the portals now (control_engine may too)
  export_customer_statement: 'export_customer_statement',   // The Engine: a customer's full statement (Excel)
  manage_engine_schedule: 'manage_engine_schedule',   // Admin > Schedules: when each engine task runs
  ask_assistant: 'ask_assistant',             // dashboard robot -> engine assistant (read-only data questions)
  manage_darb_session: 'manage_darb_session', // Darb account: connect with a token / disconnect

  // Admin
  manage_users: 'manage_users', // Acts as 'view user management'
  manage_roles: 'manage_roles', // Acts as 'view role management'

  // Petty Cash
  view_custodies: 'view_custodies',
  add_custody: 'add_custody',
  delete_custody: 'delete_custody',

  // Government Transactions
  view_government_transactions: 'view_government_transactions',
  view_branch_charges: 'view_branch_charges',

  // Traffic Fines (RTA matching engine)
  view_traffic_fines: 'view_traffic_fines',
  run_traffic_fines: 'run_traffic_fines',
  regenerate_fine_images: 'regenerate_fine_images',
  export_traffic_fines: 'export_traffic_fines',
  register_fines_on_ejar: 'register_fines_on_ejar',
  
  // Monthly Calculator Granular Permissions
  edit_monthly_leasing: 'edit_monthly_leasing',
  edit_monthly_salik: 'edit_monthly_salik',
  edit_monthly_ops: 'edit_monthly_ops',
  edit_monthly_accounts: 'edit_monthly_accounts',
};

// Human-readable labels for permissions
export const PERMISSION_LABELS = {
  // Dashboard
  view_dashboard: 'View Main Dashboard',
  view_kpi_dashboard: 'View KPI Dashboard',
  view_kpi_ops: 'KPI: View Operations Tab',
  view_kpi_employees: 'KPI: View Employees Tab',
  view_kpi_fleet: 'KPI: View Fleet Tab',
  view_kpi_contracts: 'KPI: View Contracts Tab',
  view_kpi_financial: 'KPI: View Financial Growth Tab',
  sync_kpi_data: 'KPI: Sync/Refresh Data',
  view_kpi_drilldown: 'KPI: View Detailed Drill-down',
  manage_kpi_settings: 'Manage KPI Settings',

  // Fleet Management
  view_fleet_list: 'View Fleet Page (Table)',
  view_fleet_stats: 'View Fleet Statistics (Cards)',
  view_fleet_smart: 'View Smart Mode',
  view_fleet_summary: 'View Summary Mode',
  view_fleet_expiry: 'View Expiry Filter',
  search_fleet: 'Search Fleet',
  export_fleet: 'Export Fleet Data',
  view_fleet_stat_active: 'Stat: Active Cars',
  view_fleet_stat_expired: 'Stat: Expired Cars',
  view_fleet_stat_invygo: 'Stat: Invygo/Other',

  // Contract Management
  view_contracts: 'View Contracts Page (Access)',
  search_contracts: 'Search Contracts',
  analyze_contracts_multicar: 'Multi-Car Analysis Button',
  sync_contracts: 'Refresh DB / Sync',
  edit_contracts: 'Edit / Save Changes',
  export_contracts: 'Export Contracts',
  view_contracts_tab_all: 'View Tab: All Contracts',
  view_contracts_tab_mismatch: 'View Tab: Mismatch Only',
  view_contracts_tab_switchback: 'View Tab: Switch Back',
  view_contracts_tab_expired: 'View Tab: Expired Cars',

  // Staff Management
  view_staff: 'View Staff Page',
  search_staff: 'Search Staff',
  manage_staff_data: 'Data Ops (Import/Sync)',
  share_staff_reports: 'Share (Export/Email)',
  edit_staff: 'Edit / Save Changes',
  delete_staff: 'Delete Staff',
  view_staff_stats: 'View Staff Stats',

  // Maintenance
  view_maintenance: 'View Maintenance Page',
  save_maintenance_db: 'Save to Database',
  reset_maintenance_db: 'Reset DB',
  add_maintenance_record: 'Add New Record',
  export_maintenance: 'Export Excel',
  view_incomplete_maintenance: 'View Incomplete Tab',
  view_completed_maintenance: 'View Completed Tab',
  edit_maintenance_record: 'Edit Maintenance Record',
  delete_maintenance_record: 'Delete Maintenance Record',

  // Fleet Service History
  view_service_history: 'View Fleet Service History',
  add_service_record: 'Add Service Record',
  edit_service_record: 'Edit Service Record',
  delete_service_record: 'Delete Service Record',
  add_inventory_item: 'Inventory: Add New Invoice/Batch (IN)',
  edit_inventory_item: 'Inventory: Edit Batch Details',
  delete_inventory_item: 'Inventory: Delete Batch record',
  view_service_tab: 'View Service Records Tab',
  view_inventory_tab: 'View Inventory Tab',
  view_inventory_purchase_history: 'View Purchase History (IN) View',
  view_upcoming_tab: 'View Upcoming Maintenance Tab',

  // Invoice Generator
  view_invoices: 'View Invoice Generator Page',
  view_invoice_salik: 'View Salik Tab',
  view_invoice_parking: 'View Parking Tab',
  view_invoice_traffic: 'View Traffic/Fines Tab',
  invoice_mode_upload: 'Use Upload Mode',
  invoice_mode_manual: 'Use Manual Entry Mode',
  preview_invoice: 'Preview Invoice Button',
  generate_invoice_documents: 'Generate Documents Button',

  // Petty Cash
  view_custodies: 'View Petty Cash Module',
  add_custody: 'Add New Custody',
  delete_custody: 'Delete Custody',

  // Operations Portal
  view_operations: 'View Operations Portal',
  // - Reminder
  view_ops_reminder: 'View Reminder Tool',
  ops_refunds: 'Deposit Refunds (30-day list, mark refunded)',


  // - Mileage Calculator
  view_ops_mileage: 'View Mileage Calc',
  ops_mileage_booking_input: 'Booking Number Input',
  ops_mileage_add_trip: 'Add Trip Button',
  ops_mileage_export_excel: 'Export Excel',
  ops_mileage_export_image: 'Export Image',
  ops_mileage_generate_invoice: 'Generate VAT Invoice',

  // - Fuel Calculator
  view_ops_fuel: 'View Fuel Calc',
  ops_fuel_booking_input: 'Fuel Booking Number Input',
  ops_fuel_add_trip: 'Fuel Add Trip Button',
  ops_fuel_export_excel: 'Fuel Export Excel',
  ops_fuel_export_image: 'Fuel Export Image',
  ops_fuel_generate_invoice: 'Fuel Generate VAT Invoice',

  // - Archive Cloud Sync

  // - Database Backup
  view_ops_backup: 'Download Database Backup',
  view_ops_discount: 'View Discount & Tax Calc',

  // Airport Dashboard
  view_airport_dashboard: 'View Airport Branches',

  // Booking Management
  view_booking_management: 'View Booking Management',
  booking_refresh_cloud: 'Refresh Cloud Data',
  booking_save_cloud: 'Save & Sync to Cloud',
  booking_run_check: 'Run Analysis',
  booking_refresh_cars: 'Refresh Cars DB',
  booking_reset_data: 'Reset Data (Danger Zone)',
  booking_migration_tool: 'Historical Migration Tool',
  booking_export_results: 'Export Search Results',
  booking_delete_contracts: 'Delete Contracts (Bulk)',

  // Daily Rental Report
  view_daily_booking: 'View Daily Rental Report',

  // Database
  view_database: 'View Database Page (Ejar sync + staff import)',
  import_staff: 'Import: Staff (replaces the list)',

  // Matcher Master
  view_matcher: 'View Matcher',
  matcher_tab_contracts: 'Tab: Contracts',
  matcher_tab_unrented: 'Tab: Unrented',
  matcher_tab_repeated: 'Tab: Repeated',
  matcher_tab_parking: 'Tab: Parking',
  matcher_tab_salik: 'Tab: Salik',
  matcher_action_session: 'Session (Save/Load)',
  matcher_action_export: 'Export Data Button',
  matcher_source_fleet: 'Fleet Source Selection',
  matcher_parking_view_invygo: 'Parking: Invygo View',
  matcher_parking_view_yelo: 'Parking: YELO View',
  matcher_salik_view_invygo: 'Salik: Invygo View',
  matcher_salik_view_yelo: 'Salik: YELO View',
  matcher_salik_summary: 'Salik: View Summary',
  matcher_tab_traffic: 'Tab: Traffic Fines',
  matcher_traffic_view_all: 'Traffic: View Combined (All)',
  matcher_traffic_toggle_payment: 'Traffic: Toggle Payment Status',
  matcher_traffic_export: 'Traffic: Export ZIP (5 Files)',
  matcher_tab_airport: 'Tab: Airport Contracts (YELO)',

  // History Lens
  view_history: 'View History',
  history_tab_single: 'Single Search Tab',
  history_tab_multi: 'Multi Search Tab',

  // The Engine
  view_engine: 'View The Engine page (customer search, Salik / Parking / Darb tabs)',
  use_automation: 'Read customer documents and prepare Ejar / TARS registration',
  manage_automation_settings: 'Change what the automation is allowed to write',
  save_customer_on_ejar: 'Automation: open a case, fill Ejar\'s screen and save the customer in Ejar',
  pull_salik: 'Pull Salik / parking / Darb from the portals now (also the customer profile\'s "Pull missing days")',
  export_customer_statement: 'Engine: download a customer\'s full statement (Excel - phone, identity, payments)',
  control_engine: 'Register to Ejar, pull from Salik / Darb, mark rows, apply self-check fixes',
  manage_engine_schedule: 'Schedules: change when each engine task runs (RTA, Ejar, Salik, reports)',
  ask_assistant: 'AI Assistant: ask the engine data questions (contract statement, fines, Salik, who has a car)',
  manage_darb_session: 'Portal sessions: Darb token, Salik session handoff, disconnect',

  // Database Write Permissions
  write_fleet: 'Write to Fleet Database',
  write_contracts: 'Write to Contracts Database',
  write_staff: 'Write to Staff Database',
  write_custodies: 'Write to Custodies Database',
  write_expenses: 'Write to Expenses Database',
  write_settlements: 'Write to Settlements Database',

  // Admin
  manage_users: 'User Management page (see users; password help, creating, changing, locking and deleting users need the Admin role)',
  manage_roles: 'Role Management page (see roles; changing them needs the Admin role)',
  view_government_transactions: 'View Government Transactions Page',
  view_branch_charges: 'View Branch Charges (fines, Salik, Darb, parking per branch)',
  view_traffic_fines: 'View Traffic Fines Page',
  run_traffic_fines: 'Run Fines Processing',
  regenerate_fine_images: 'Regenerate Fine Images',
  export_traffic_fines: 'Export Fines (company template)',
  register_fines_on_ejar: 'Register Fines on Ejar (by hand on each contract\'s screen, under your own Ejar login)',

  // Monthly Calculator Granular Permissions Labels
  edit_monthly_leasing: 'Edit Leasing Fields (Rent, Identity, Limit)',
  edit_monthly_salik: 'Edit Salik Charges',
  edit_monthly_ops: 'Edit Operations Fields (Other, End KM)',
  edit_monthly_accounts: 'Edit Accounts Fields (PAID, INV NO)',
};

// Module display names
export const MODULE_LABELS = {
  dashboard: 'Dashboard',
  kpi: 'KPI Dashboard',
  fleet: 'Fleet Management',
  contracts: 'Monthly Management',
  monthly_calculator: 'Monthly Calculator',
  booking_management: 'Booking Management',
  daily_booking: 'Daily Rental Report',
  airport_dashboard: 'Airport Branches',
  staff: 'Staff Management',
  maintenance: 'Cars Maintenance',
  fleet_service_history: 'Fleet Service History',
  invoices: 'Invoice Generator',
  operations: 'Operations Portal',
  custodies: 'Petty Cash',
  government_transactions: 'Government Transactions',
  branch_charges: 'Branch Charges (Accounts)',
  matcher: 'Matcher Master',
  history: 'History Lens',
  traffic_fines: 'Traffic Fines',
  engine: 'The Engine (Salik / Parking / Darb)',
  automation: 'Customer Automation (Ejar + TARS)',
  database: 'Database (Imports)',
  database_write: 'Database Write Access (Advanced)',
  admin: 'Administration'
};

// Sections of the permissions editor, in the order they are shown (a group missing
// here is appended at the end, so nothing can ever be left unassignable).
export const MODULE_ORDER = [
  'dashboard', 'kpi', 'fleet', 'contracts', 'monthly_calculator', 'booking_management', 'daily_booking',
  'airport_dashboard', 'staff', 'maintenance', 'fleet_service_history', 'invoices', 'operations', 'custodies',
  'government_transactions', 'branch_charges', 'matcher', 'history', 'traffic_fines', 'engine', 'automation', 'database', 'database_write', 'admin'
];

// Short descriptions shown under each section title.
export const MODULE_HINTS = {
  monthly_calculator: 'Which columns of the monthly leasing calculator a user may edit',
  database_write: 'Raw write access to the Firestore collections - grant with care',
  engine: 'Other charges (Salik, parking, Abu Dhabi Darb) onto Ejar contracts',
  automation: 'Reading the customer documents and filling Ejar and TARS from them',
  traffic_fines: 'RTA fines engine: viewing is separate from running and uploading',
  admin: 'User and role administration'
};

export const PERMISSION_GROUPS = {
  dashboard: [
    'view_dashboard'
  ],
  kpi: [
    'view_kpi_dashboard',
    'view_kpi_ops',
    'view_kpi_employees',
    'view_kpi_fleet',
    'view_kpi_contracts',
    'view_kpi_financial',
    'sync_kpi_data',
    'view_kpi_drilldown',
    'manage_kpi_settings'
  ],
  fleet: [
    'view_fleet_list',
    'view_fleet_stats',
    'view_fleet_smart',
    'view_fleet_summary',
    'view_fleet_expiry',
    'search_fleet',
    'export_fleet',
    'view_fleet_stat_active',
    'view_fleet_stat_expired',
    'view_fleet_stat_invygo'
  ],
  contracts: [
    'view_contracts',
    'search_contracts',
    'analyze_contracts_multicar',
    'sync_contracts',
    'edit_contracts',
    'export_contracts',
    'view_contracts_tab_all',
    'view_contracts_tab_mismatch',
    'view_contracts_tab_switchback',
    'view_contracts_tab_expired'
  ],
  monthly_calculator: [
    PERMISSIONS.edit_monthly_leasing,
    PERMISSIONS.edit_monthly_salik,
    PERMISSIONS.edit_monthly_ops,
    PERMISSIONS.edit_monthly_accounts,
  ],
  staff: [
    PERMISSIONS.view_staff,
    PERMISSIONS.search_staff,
    PERMISSIONS.manage_staff_data,
    PERMISSIONS.share_staff_reports,
    PERMISSIONS.edit_staff,
    PERMISSIONS.delete_staff,
    PERMISSIONS.view_staff_stats
  ],
  maintenance: [
    PERMISSIONS.view_maintenance,
    PERMISSIONS.add_maintenance_record,
    PERMISSIONS.save_maintenance_db,
    PERMISSIONS.reset_maintenance_db,
    PERMISSIONS.export_maintenance,
    PERMISSIONS.view_incomplete_maintenance,
    PERMISSIONS.view_completed_maintenance,
    PERMISSIONS.edit_maintenance_record,
    PERMISSIONS.delete_maintenance_record
  ],
  fleet_service_history: [
    PERMISSIONS.view_service_history,
    PERMISSIONS.add_service_record,
    PERMISSIONS.edit_service_record,
    PERMISSIONS.delete_service_record,
    PERMISSIONS.add_inventory_item,
    PERMISSIONS.edit_inventory_item,
    PERMISSIONS.delete_inventory_item,
    PERMISSIONS.view_service_tab,
    PERMISSIONS.view_inventory_tab,
    PERMISSIONS.view_inventory_purchase_history,
    PERMISSIONS.view_upcoming_tab
  ],
  invoices: [
    PERMISSIONS.view_invoices,
    PERMISSIONS.view_invoice_salik,
    PERMISSIONS.view_invoice_parking,
    PERMISSIONS.view_invoice_traffic,
    PERMISSIONS.invoice_mode_upload,
    PERMISSIONS.invoice_mode_manual,
    PERMISSIONS.preview_invoice,
    PERMISSIONS.generate_invoice_documents
  ],

  operations: [
    'view_operations',
    // Reminder
    'view_ops_reminder',
    'ops_refunds',
    // RTA
    // Mileage
    'view_ops_mileage',
    'ops_mileage_booking_input',
    'ops_mileage_add_trip',
    'ops_mileage_export_excel',
    'ops_mileage_export_image',
    'ops_mileage_generate_invoice',

    // Fuel
    'view_ops_fuel',
    'ops_fuel_booking_input',
    'ops_fuel_add_trip',
    'ops_fuel_export_excel',
    'ops_fuel_export_image',
    'ops_fuel_generate_invoice',

    'view_ops_backup',
    'view_ops_discount'
  ],
  airport_dashboard: [
    'view_airport_dashboard'
  ],
  booking_management: [
    'view_booking_management',
    'booking_refresh_cloud',
    'booking_save_cloud',
    'booking_run_check',
    'booking_refresh_cars',
    'booking_reset_data',
    'booking_migration_tool',
    'booking_export_results',
    'booking_delete_contracts'
  ],
  daily_booking: ['view_daily_booking'],
  database: [
    'view_database',
    'import_staff'
  ],
  database_write: [
    'write_fleet',
    'write_contracts',
    'write_staff',
    'write_custodies',
    'write_expenses',
    'write_settlements'
  ],
  matcher: [
    'view_matcher',
    'matcher_tab_contracts',
    'matcher_tab_unrented',
    'matcher_tab_repeated',
    'matcher_tab_parking',
    'matcher_tab_salik',
    'matcher_action_session',
    'matcher_action_export',
    'matcher_source_fleet',
    'matcher_parking_view_invygo',
    'matcher_parking_view_yelo',
    'matcher_salik_view_invygo',
    'matcher_salik_view_yelo',
    'matcher_salik_summary',
    'matcher_tab_traffic',
    'matcher_traffic_view_all',
    'matcher_traffic_toggle_payment',
    'matcher_traffic_export',
    'matcher_tab_airport'
  ],
  history: [
    'view_history',
    'history_tab_single',
    'history_tab_multi'
  ],
  engine: ['view_engine', 'control_engine', 'pull_salik', 'export_customer_statement', 'manage_darb_session',
           'manage_engine_schedule', 'ask_assistant'],
  automation: ['use_automation', 'save_customer_on_ejar', 'manage_automation_settings'],
  admin: ['manage_users', 'manage_roles'],
  custodies: ['view_custodies', 'add_custody', 'delete_custody'],
  government_transactions: ['view_government_transactions'],
  branch_charges: ['view_branch_charges'],
  traffic_fines: ['view_traffic_fines', 'run_traffic_fines', 'regenerate_fine_images', 'export_traffic_fines', 'register_fines_on_ejar']
};

export const DEFAULT_ROLES = {
  admin: {
    name: 'Admin',
    permissions: Object.values(PERMISSIONS)
  },
  manager: {
    name: 'Manager',
    permissions: [
      // Dashboard
      PERMISSIONS.view_dashboard,
      PERMISSIONS.view_kpi_dashboard,
      PERMISSIONS.view_kpi_ops,
      PERMISSIONS.view_kpi_employees,
      PERMISSIONS.view_kpi_fleet,
      PERMISSIONS.view_kpi_contracts,
      PERMISSIONS.view_kpi_financial,
      PERMISSIONS.sync_kpi_data,
      PERMISSIONS.view_kpi_drilldown,
      PERMISSIONS.manage_kpi_settings,

      // Fleet Management
      PERMISSIONS.view_fleet_list,
      PERMISSIONS.view_fleet_smart,
      PERMISSIONS.view_fleet_summary,
      PERMISSIONS.view_fleet_expiry,
      PERMISSIONS.search_fleet,
      PERMISSIONS.export_fleet,
      PERMISSIONS.view_fleet_stats,
      PERMISSIONS.view_fleet_stat_active,
      PERMISSIONS.view_fleet_stat_expired,
      PERMISSIONS.view_fleet_stat_invygo,

      // Contract Management
      PERMISSIONS.view_contracts,
      PERMISSIONS.search_contracts,
      PERMISSIONS.analyze_contracts_multicar,
      PERMISSIONS.sync_contracts,
      PERMISSIONS.edit_contracts,
      PERMISSIONS.export_contracts,
      PERMISSIONS.view_contracts_tab_all,
      PERMISSIONS.view_contracts_tab_mismatch,
      PERMISSIONS.view_contracts_tab_switchback,
      PERMISSIONS.view_contracts_tab_expired,

      // Staff Management
      PERMISSIONS.view_staff,
      PERMISSIONS.search_staff,
      PERMISSIONS.manage_staff_data,
      PERMISSIONS.share_staff_reports,
      PERMISSIONS.edit_staff,
      PERMISSIONS.delete_staff,
      PERMISSIONS.view_staff_stats,

      // Maintenance
      PERMISSIONS.view_maintenance,
      PERMISSIONS.save_maintenance_db,
      PERMISSIONS.reset_maintenance_db,
      PERMISSIONS.add_maintenance_record,
      PERMISSIONS.export_maintenance,
      PERMISSIONS.view_incomplete_maintenance,
      PERMISSIONS.view_completed_maintenance,
      PERMISSIONS.edit_maintenance_record,
      PERMISSIONS.delete_maintenance_record,
      PERMISSIONS.view_service_history,
      PERMISSIONS.add_service_record,
      PERMISSIONS.edit_service_record,
      PERMISSIONS.delete_service_record,
      PERMISSIONS.add_inventory_item,
      PERMISSIONS.edit_inventory_item,
      PERMISSIONS.delete_inventory_item,
      PERMISSIONS.view_service_tab,
      PERMISSIONS.view_inventory_tab,
      PERMISSIONS.view_inventory_purchase_history,
      PERMISSIONS.view_upcoming_tab,

      // Invoice Generator
      PERMISSIONS.view_invoices,
      PERMISSIONS.view_invoice_salik,
      PERMISSIONS.view_invoice_parking,
      PERMISSIONS.view_invoice_traffic,
      PERMISSIONS.invoice_mode_upload,
      PERMISSIONS.invoice_mode_manual,
      PERMISSIONS.preview_invoice,
      PERMISSIONS.generate_invoice_documents,

      // Operations Portal
      PERMISSIONS.view_operations,
      PERMISSIONS.view_ops_reminder,
      PERMISSIONS.ops_refunds,
      PERMISSIONS.view_ops_mileage,
      PERMISSIONS.ops_mileage_booking_input,
      PERMISSIONS.ops_mileage_add_trip,
      PERMISSIONS.ops_mileage_export_excel,
      PERMISSIONS.ops_mileage_export_image,
      PERMISSIONS.ops_mileage_generate_invoice,

      // Fuel
      PERMISSIONS.view_ops_fuel,
      PERMISSIONS.ops_fuel_booking_input,
      PERMISSIONS.ops_fuel_add_trip,
      PERMISSIONS.ops_fuel_export_excel,
      PERMISSIONS.ops_fuel_export_image,
      PERMISSIONS.ops_fuel_generate_invoice,

      PERMISSIONS.view_ops_backup,
      PERMISSIONS.view_ops_discount,
      PERMISSIONS.view_airport_dashboard,

      // Booking Management
      PERMISSIONS.view_booking_management,
      PERMISSIONS.booking_refresh_cloud,
      PERMISSIONS.booking_save_cloud,
      PERMISSIONS.booking_run_check,
      PERMISSIONS.booking_refresh_cars,
      PERMISSIONS.booking_reset_data,
      PERMISSIONS.booking_migration_tool,
      PERMISSIONS.booking_export_results,
      PERMISSIONS.booking_delete_contracts,

      // Daily Rental Report
      PERMISSIONS.view_daily_booking,

      // Database (the Ejar sync panel + the staff import)
      PERMISSIONS.view_database,
      PERMISSIONS.import_staff,

      // Matcher Master
      PERMISSIONS.view_matcher,
      PERMISSIONS.matcher_tab_contracts,
      PERMISSIONS.matcher_tab_unrented,
      PERMISSIONS.matcher_tab_repeated,
      PERMISSIONS.matcher_tab_parking,
      PERMISSIONS.matcher_tab_salik,
      PERMISSIONS.matcher_action_session,
      PERMISSIONS.matcher_action_export,
      PERMISSIONS.matcher_source_fleet,
      PERMISSIONS.matcher_parking_view_invygo,
      PERMISSIONS.matcher_parking_view_yelo,
      PERMISSIONS.matcher_salik_view_invygo,
      PERMISSIONS.matcher_salik_view_yelo,
      PERMISSIONS.matcher_salik_summary,
      PERMISSIONS.matcher_tab_traffic,
      PERMISSIONS.matcher_traffic_view_all,
      PERMISSIONS.matcher_traffic_toggle_payment,
      PERMISSIONS.matcher_traffic_export,
      PERMISSIONS.matcher_tab_airport,

      // History Lens
      PERMISSIONS.view_history,
      PERMISSIONS.history_tab_single,
      PERMISSIONS.history_tab_multi,

      // The Engine
      PERMISSIONS.view_engine,
      PERMISSIONS.control_engine,

      // Petty Cash
      PERMISSIONS.view_custodies,
      PERMISSIONS.add_custody,
      PERMISSIONS.delete_custody,
      PERMISSIONS.view_government_transactions,
      PERMISSIONS.view_traffic_fines,
      // Processing tab, Sync from RTA, Process now, Ejar checks: admin only by
      // default - grant run_traffic_fines per user when needed.
      PERMISSIONS.export_traffic_fines,
      PERMISSIONS.register_fines_on_ejar,
      PERMISSIONS.ask_assistant,

      // Database Write Permissions
      PERMISSIONS.write_fleet,
      PERMISSIONS.write_contracts,
      PERMISSIONS.write_staff,
      PERMISSIONS.write_custodies,
      PERMISSIONS.write_expenses,
      PERMISSIONS.write_settlements
    ]
  },
  viewer: {
    name: 'Viewer',
    permissions: [
      // Dashboard
      PERMISSIONS.view_dashboard,

      // Fleet Management (Read-only)
      PERMISSIONS.view_fleet_list,
      PERMISSIONS.view_fleet_smart,
      PERMISSIONS.view_fleet_summary,
      PERMISSIONS.view_fleet_expiry,
      PERMISSIONS.search_fleet,
      PERMISSIONS.view_fleet_stats,
      PERMISSIONS.view_fleet_stat_active,
      PERMISSIONS.view_fleet_stat_expired,
      PERMISSIONS.view_fleet_stat_invygo,

      // Contract Management (Read-only)
      PERMISSIONS.view_contracts,
      PERMISSIONS.search_contracts,
      PERMISSIONS.view_contracts_tab_all,
      PERMISSIONS.view_contracts_tab_mismatch,
      PERMISSIONS.view_contracts_tab_switchback,
      PERMISSIONS.view_contracts_tab_expired,

      // Staff Management (Read-only)
      PERMISSIONS.view_staff,
      PERMISSIONS.search_staff,
      PERMISSIONS.view_staff_stats,

      // Maintenance (Read-only)
      PERMISSIONS.view_maintenance,
      PERMISSIONS.view_incomplete_maintenance,
      PERMISSIONS.view_completed_maintenance,
      PERMISSIONS.view_service_history,
      PERMISSIONS.view_service_tab,
      PERMISSIONS.view_inventory_tab,
      PERMISSIONS.view_upcoming_tab,

      // Invoice Generator (Read-only)
      PERMISSIONS.view_invoices,
      PERMISSIONS.view_invoice_salik,
      PERMISSIONS.view_invoice_parking,
      PERMISSIONS.view_invoice_traffic,
      PERMISSIONS.preview_invoice,

      // Operations Portal (Read-only)
      PERMISSIONS.view_operations,
      PERMISSIONS.view_ops_reminder,
      PERMISSIONS.view_ops_mileage,

      // Booking Management (Read-only)
      PERMISSIONS.view_booking_management,

      // Daily Rental Report
      PERMISSIONS.view_daily_booking,

      // Matcher Master (Read-only)
      PERMISSIONS.view_matcher,
      PERMISSIONS.matcher_tab_contracts,
      PERMISSIONS.matcher_tab_unrented,
      PERMISSIONS.matcher_tab_repeated,
      PERMISSIONS.matcher_tab_parking,
      PERMISSIONS.matcher_tab_salik,
      PERMISSIONS.matcher_parking_view_invygo,
      PERMISSIONS.matcher_parking_view_yelo,
      PERMISSIONS.matcher_salik_view_invygo,
      PERMISSIONS.matcher_salik_view_yelo,
      PERMISSIONS.matcher_salik_summary,
      PERMISSIONS.matcher_tab_traffic,
      PERMISSIONS.matcher_traffic_view_all,
      // History Lens
      PERMISSIONS.view_history,
      PERMISSIONS.history_tab_single,
      PERMISSIONS.history_tab_multi,

      // The Engine (Read-only)
      PERMISSIONS.view_engine,

      // Petty Cash (Read-only)
      PERMISSIONS.view_custodies
    ]
  }
};

// -- the catalogue (permissionCatalog.js - owner's permissions plan, 3 Oct 2026): its new permissions join every list,
//    the ones no button uses leave them, and the default roles are upgraded the way the stored ones are
NEW_KEYS_LIST.forEach(({ key, label, page }) => {
  PERMISSIONS[key] = key;
  PERMISSION_LABELS[key] = PERMISSION_LABELS[key] || label;
  PERMISSION_GROUPS[page] = [...(PERMISSION_GROUPS[page] || []), key];
});
DEAD_KEYS.forEach((key) => {
  delete PERMISSIONS[key];
  delete PERMISSION_LABELS[key];
  Object.keys(PERMISSION_GROUPS).forEach((g) => { PERMISSION_GROUPS[g] = PERMISSION_GROUPS[g].filter((k) => k !== key); });
});
Object.keys(DEFAULT_ROLES).forEach((id) => {
  DEFAULT_ROLES[id] = { ...DEFAULT_ROLES[id],
    permissions: id === 'admin' ? Object.values(PERMISSIONS) : upgradeRole(DEFAULT_ROLES[id].permissions).permissions };
});
